import LoadingSpinner from '@ui/components/LoadingSpinner';
import Logo from '@ui/components/Logo';

import styles from './SplashScreen.module.scss';

export default function SplashScreen() {
    return (
        <div className={styles['splash-screen']}>
            <header className={styles['header']}>
                <Logo variant="secondary" height={48} />
            </header>
            <main className={styles['loading-spinner-wrapper']}>
                <LoadingSpinner />
            </main>
            <footer className={styles['footer-spacer']} />
        </div>
    );
}
